import React from "react";
import { Dropdown } from "react-bootstrap";
import { Sliders } from "react-feather";

// Reusable "manage columns" control - a small toolbar button opening a
// checklist of every column, so any column hidden via its own header's `x`
// (see DataTable column `title` wrapping) can be re-enabled again from here
// without losing the rest of the current filter/sort state. `columns` is
// [{ key, label }]; `hidden` is the array of currently-hidden keys.
const ColumnVisibilityMenu = ({ columns, hidden, onToggle }) => (
  <Dropdown align="end">
    <Dropdown.Toggle variant="outline-secondary" size="sm" className="d-inline-flex align-items-center">
      <Sliders size={14} className="me-1" />
      Columns
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {columns.map((col) => (
        <Dropdown.Item
          as="label"
          key={col.key}
          className="d-flex align-items-center gap-2 mb-0"
          onClick={(e) => e.stopPropagation()}
        >
          <input type="checkbox" checked={!hidden.includes(col.key)} onChange={() => onToggle(col.key)} />
          {col.label}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

export default ColumnVisibilityMenu;
